import { ShipmentRequestResponse } from '@/modules/shipments-module/services/shipments.dto'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { shipmentsModalSendGridColumnsDef } from '@/modules/shipments-module/components/modal-send/columns-definition/shipments-modal-send-grid.columns-def'

export interface ShipmentsModalSendState {
    shipments: ShipmentRequestResponse[]
    activeTabIndex: number
    rowData: ShipmentRequestResponse[]
    columnDefs: ColDef[]
    observations: string
}
export const initialShipmentsModalSendState =
    (): ShipmentsModalSendState => ({
        shipments: [],
        activeTabIndex: -1,
        rowData: [],
        columnDefs: shipmentsModalSendGridColumnsDef,
        observations: ''
    })
